import axios, { AxiosResponse } from 'axios'
import { Response } from '../../../_metronic/helpers'
import {Option} from "react-multi-select-component";
import { IProductAvaliable } from '../../../coreGlobal/models/schedules/scheduleAvaliable';

const API_URL = process.env.REACT_APP_API_URL + '/api'

const getProducts = (category: string, signal: AbortSignal | undefined = undefined): Promise<Option[] | undefined> => {
    const options = category.length ? `?category=${category}` : ''
    return axios.get(`${API_URL}/products/all${options}`, { signal })
        .then((response: AxiosResponse<Response<Option[]>>) => response.data)
        .then((response: Response<Option[]>) => response.data)
}
const getClientAvailableItems = (peopleId: string, signal: AbortSignal | undefined = undefined): Promise<IProductAvaliable[] | undefined> => {
    return axios
        .get(`${API_URL}/people/${peopleId}/available-items`, { signal })
        .then((response: AxiosResponse<Response<IProductAvaliable[]>>) => response.data)
        .then((response: Response<IProductAvaliable[]>) => response.data)
}

const getRoomIdById = (roomId: string | number) => {
    return axios
      .get(`${API_URL}/rooms/${roomId}?include=categories,products,machines,intervals`)
      .then((response: any) => response.data)
      .then((response: any) => response.data)
}

export { getRoomIdById, getClientAvailableItems, getProducts};